import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Card, CardBody, CardSubtitle, CardTitle } from 'reactstrap'

import EmailCampaignsTable from './partials/EmailCampaignsTable'

import { campaignsGeneralReport } from './services'
import { handleError } from '../../helpers'

export default function GeneralEmailCampaignsReport() {
    const [emailCampaigns, setEmailCampaigns] = useState(null)

    useEffect(() => {
        !emailCampaigns && campaignsGeneralReport({
            'report_type': 'email_campaigns'
        })
            .then(res => setEmailCampaigns(res.data.data.data))
            .catch(error => handleError(error))
    }, [ emailCampaigns ])

    return (
        <React.Fragment>
            <Card>
				<CardBody>
					<div className='float-right'>
						<Link to="/dashboards/campaigns">
							<Button color="primary" outline>Ver otros reportes</Button>
						</Link>
					</div>
					<CardTitle>Reporte General de Campañas</CardTitle>
					<CardSubtitle>Campañas de email marketing enviadas masivamente</CardSubtitle>
				</CardBody>
			</Card>
            <Card>
				<CardBody>
                    <EmailCampaignsTable 
                        campaigns={emailCampaigns}
                    />
                </CardBody>
            </Card>
        </React.Fragment>
    )
}